﻿import {DestinyDefinitionsLoader} from "./DestinyDefinitionsLoader";
import {DestinyDefinitionsWorkerMessages} from "./DestinyDefinitionsWorkerMessages";

DestinyDefinitionsLoader.setMessageSender((data) => {
	self.postMessage(data);
})

/**
NOTES ABOUT THIS FILE

This is a worker. It is different from the rest of the code because it runs on a separate thread.
It has a very specific responsibility - loading definitions into and out of IndexedDB.
When I created it, I was having trouble using it as a TypeScript file, becuase I needed to do a bunch of imports to get the types correct.
Those imports caused problems with the webpack build, because workers don't have access to things like document or window. Thus, you cannot import files
that use those things. The only way that felt good to avoid this was to avoid the types altogether and just let this thing be a JS file.
 */

/* eslint-disable no-restricted-globals */

// Respond to message from parent thread
// Note: 'self' refers to the worker itself, and the variable is made available in the webpack configurations as a global
self.addEventListener("message", (event) =>
{
	const data = event.data;
	switch (data.name)
	{
		case "load":
			DestinyDefinitionsLoader.load(data.detail)
				.then(definitionsObj => {
					
					// Send the definitions back to the requester
					self.postMessage({
						name: DestinyDefinitionsWorkerMessages.LOADED_DEFINITIONS,
						detail: {
							definitions: JSON.stringify(definitionsObj)
						}
					});
					
				})
			break;

		default:
			throw new Error("Not a valid name");
	}
});

export default {};
